import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20gradient%20background%20with%20soft%20coral%20and%20golden%20amber%20tones%2C%20abstract%20flowing%20organic%20shapes%2C%20dreamy%20bokeh%20effect%2C%20gentle%20light%20rays%20from%20top%20right%2C%20warm%20inviting%20mood%2C%20modern%20minimalist%20design%20with%20luxurious%20feel%2C%20no%20text%20or%20faces&width=1600&height=900&seq=cta-bg-01&orientation=landscape"
          alt="订阅黑料吃瓜网"
          title="不错过任何黑料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 tracking-wide leading-tight">
            不错过任何黑料
          </h2>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 leading-relaxed">
            订阅黑料吃瓜网，第一时间收到最新爆料推送
            <br />
            吃瓜不迷路，入口永在线
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="w-full sm:w-auto inline-flex items-center gap-3 px-6 py-3 rounded-full bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-sm text-background-50"></i>
              </span>
              立即吃瓜
              <i className="ri-arrow-right-up-line"></i>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-6 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}